import React, { useEffect, useState } from 'react';
import BaseTable from '@app/components/common/Table/BaseTable';
import {
  Form,
  Input,
  Select,
  Button,
  message,
  Space,
  InputNumber,
  Checkbox,
  DatePicker,
  Card,
  Modal,
  Row,
  Col,
  Radio,
  Table,
  Alert,
} from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { formatNumberInInput, formatMoney } from '@app/utils/utils';
import moment from 'moment';
import { FaInfoCircle } from 'react-icons/fa';
import { MdCancel, MdReceipt } from 'react-icons/md';
import { EmployeeModel } from '@app/interfaces/employee';
//import { OrderModel } from '@app/interfaces/order';
import { TbCash } from 'react-icons/tb';
import { CiBank } from 'react-icons/ci';
import { getListEmployees } from '@app/api/order.api';
import { CustomerModel, CustomerOrder } from '@app/interfaces/customer';
import { DATE_FORMAT } from '@app/constants/dateFormats';

interface ModalProps {
  open: boolean;
  onCreate: (values: any) => void;
  onCancel: () => void;
  title: string;
  customer: CustomerModel;
  orders: CustomerOrder[] | null;
}

const PaymentOrderForm: React.FC<ModalProps> = ({ open, onCreate, onCancel, title, customer, orders }) => {
  const [form] = Form.useForm();
  const [date, setDate] = useState(moment());
  const [employeerOptions, setEmployeerOptions] = useState<{ value: number; label: string }[]>([]);

  useEffect(() => {
    form.setFieldsValue({
      name: `Thanh toán đơn hàng`,
      trans_date: moment(),
      payee_recipient_type: 'Khách hàng',
      payee_recipient_name: customer.name,
      recognize_income_statement: true,
    });
  }, [open, orders]);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const response = await getListEmployees();

      const options = response?.map((item: any) => ({
        value: item.id,
        label: item.name,
      }));

      setEmployeerOptions(options);
    } catch (error: any) {
      message.error(error.message);
    }
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        console.log(values);
        //form.resetFields();

        const formattedData = {
          ...values,
          transaction_type: 'receivable',
          posted: true,
          store_id: customer.store_id,
        };

        onCreate(values);
      })
      .catch((info) => {
        console.log('Validate failed:', info);
      });
  };

  const onDateChange = (value: any) => {
    setDate(value);
  };

  const onChangeEmployee = (value: string) => {
    form.setFieldsValue({ seller: value });
  };

  const totalDebitAmount = Math.abs(orders?.reduce((sum, order) => sum + order.debit_amount, 0) ?? 0);

  return (
    <>
      <Modal
        open={open}
        onOk={() => {
          const values = form.getFieldsValue();
          onCreate(values);
        }}
        onCancel={onCancel}
        width={1000}
        style={{ top: 20 }}
        closable={false}
        footer={[
          <Space>
            <Button onClick={handleSubmit} type="primary">
              <MdReceipt /> Thanh toán
            </Button>
            <Button onClick={onCancel} type="primary" danger>
              {' '}
              <MdCancel /> Bỏ qua
            </Button>
          </Space>,
        ]}
      >
        <Form form={form} layout="vertical" name="form-ledger" size="small">
          <h3 className="mb-4 font-bold-weight">{title}</h3>

          <Alert
            message="Thanh toán nhanh đơn hàng"
            description={`Bạn có chắc chắn thanh toán ${orders?.length} đơn hàng này?"`}
            type="warning"
            banner
            closable
            className="text-primary my-3"
          />

          <Row gutter={12}>
            <Col span={12}>
              <Card style={{ height: '100%' }}>
                {/* <Row gutter={12}>
                  <Col span={6}>Diễn giải</Col>
                  <Col span={18}>
                    <Form.Item name="name" rules={[{ required: true, message: 'Please input name!' }]}>
                      <Input placeholder="Diễn giải" />
                    </Form.Item>
                  </Col>
                </Row> */}
                <Row gutter={12}>
                  <Col span={6}>Thời gian</Col>
                  <Col span={18}>
                    <Form.Item name="trans_date">
                      <DatePicker showToday format={DATE_FORMAT} onChange={onDateChange} value={date} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={6}>Nhân viên thu</Col>
                  <Col span={18}>
                    <Form.Item name="employee_id" rules={[{ required: true, message: 'Chọn nhân viên thu!' }]}>
                      <Select
                        allowClear
                        showSearch
                        placeholder="Nhân viên thu"
                        optionFilterProp="children"
                        onChange={onChangeEmployee}
                        filterOption={(input, option) =>
                          (option?.label?.toString() ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        options={employeerOptions}
                        suffixIcon={<UserOutlined className="text-primary" />}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={12}>
                  <Col span={6}>Ghi chú</Col>
                  <Col span={18}>
                    <Form.Item name="remark">
                      <Input.TextArea placeholder="Ghi chú" autoSize={{ maxRows: 6 }} />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col span={12}>
              <Card style={{ height: '100%' }}>
                <Row gutter={12}>
                  <Col span={6}>Đối tượng nộp</Col>
                  <Col span={18}>
                    <Form.Item name="payee_recipient_type">
                      <Input readOnly />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={12}>
                  <Col span={6}>Tên khách hàng</Col>
                  <Col span={18}>
                    <Form.Item name="payee_recipient_name">
                      <Input readOnly />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={12}>
                  <Col span={6}></Col>
                  <Col span={18}>
                    <Form.Item name="payment_type">
                      <Radio.Group defaultValue="cash">
                        <Radio value="cash">
                          <TbCash /> Tiền mặt
                        </Radio>
                        <Radio value="bank_transfer">
                          <CiBank /> Chuyển khoản
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <BaseTable
            className="mt-4"
            dataSource={orders || []}
            rowKey="order_id"
            pagination={false}
            bordered
            scroll={{ x: true }}
            summary={() => (
              <Table.Summary.Row className="text-bold text-primary">
                <Table.Summary.Cell index={0} colSpan={2}>
                  Tổng thanh toán:
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} className="text-right">
                  {formatMoney(totalDebitAmount)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            )}
          >
            <Table.Column
              title="Mã đơn hàng"
              dataIndex="order_code"
              key="order_code"
              render={(order_code: string) => <span>{order_code}</span>}
            />
            <Table.Column
              title="Giá trị đơn hàng"
              dataIndex="amount"
              key="amount"
              className="text-right"
              render={(amount: number) => <span>{formatNumberInInput(Number(amount))} VND</span>}
            />
            <Table.Column
              title="Công nợ cần thanh toán"
              dataIndex="debit_amount"
              key="debit_amount"
              className="text-right"
              render={(debit_amount: number) => (
                <span className="text-primary">{formatNumberInInput(Math.abs(Number(debit_amount || 0)))} VND</span>
              )}
            />
          </BaseTable>
        </Form>
      </Modal>
    </>
  );
};

export default PaymentOrderForm;
